import { Controller } from "@hotwired/stimulus"

// Manages a lookup row: hex color pickers + alpha slider → live badge preview + hidden rgba fields
export default class extends Controller {
  static targets = ["badge", "bgPicker", "textPicker", "alphaSlider", "alphaDisplay", "bgColorField", "textColorField"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const bgHex = this.bgPickerTarget.value
    const alpha = this.alphaSliderTarget.value
    const textHex = this.textPickerTarget.value

    const bgRgba = this.hexToRgba(bgHex, alpha)
    const textRgba = this.hexToRgba(textHex, 1)

    // Update hidden fields with rgba values
    this.bgColorFieldTarget.value = bgRgba
    this.textColorFieldTarget.value = textRgba

    // Update badge preview
    this.badgeTarget.style.backgroundColor = bgRgba
    this.badgeTarget.style.color = textRgba

    // Update alpha label
    this.alphaDisplayTarget.textContent = `${Math.round(alpha * 100)}%`
  }

  hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
}
